module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e53ff4a140871927b2d5be4f5cdb2c79.svg";